import { SponsorCompanyTier } from "src/api/types.generated";

export const PROMOTION_TYPE_OPTIONS_BY_TIER: Record<
  SponsorCompanyTier,
  string[]
> = {
  [SponsorCompanyTier.Bronze]: ["Story"],
  [SponsorCompanyTier.Startup]: ["Story"],
  [SponsorCompanyTier.Partner]: ["Story"],
  [SponsorCompanyTier.Silver]: ["Story", "Post"],
  [SponsorCompanyTier.Gold]: ["Story", "Post", "Reel"],
  [SponsorCompanyTier.Vc]: ["Story", "Post", "Reel"],
};

export const DEFAULT_PROMOTION_TYPE_OPTIONS = ["Story"];
